<template>
  <v-dialog :scrollable="true" v-model="dialog" max-width="500px">
    <v-card
      class="py-2 strategio-card-container"
    >
      <v-card-title
        class="py-2 justify-center"
        style="font-size:20px;font-weight:500;"
      >
        Distribuidoras
        <v-spacer></v-spacer>
        <v-btn
          small depressed round dark
          style="background-color:#00C3D7"
          @click="editItem({})"
        >Agregar</v-btn>
      </v-card-title>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <!-- etiqueta div importante para  evitar
      que container coja todo el espacio disponible -->
      <div>
        <v-container class="py-1 pb-2">
          <v-layout>
            <v-flex>
              <v-text-field
                v-model="distributorFilter"
                label="Filtrar"
                placeholder="Nombre de distribuidora"
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-text>
        <template v-if="filteredDistributors.length > 0">
          <template v-for="(item, index) in filteredDistributors">
            <div :key="index">
              <v-layout row align-center>
                <v-flex align-center>
                  <v-icon :color="statusColorItem(item)">fiber_manual_record</v-icon>
                </v-flex>
                <v-flex xs12 class="px-2 py-1 text-xs-left" style="line-height:normal;">
                  <v-layout column>
                    <v-flex>
                      <span style="font-size:14px;font-weight:bold;text-transform:capitalize;">{{ item.distributorName.toLowerCase() || '~NO DEFINIDO~' }}</span>
                    </v-flex>
                    <v-flex>
                      <span style="font-size:11px;">
                        {{ item.remoteFileName.replace('/home/validata_mdlz_7318', '~') || '~NO DEFINIDO~' }}
                      </span>
                    </v-flex>
                  </v-layout>
                  <!-- <span style="font-weight:bold">{{ item.distributorName || '~NO DEFINIDO~' }}</span> - {{ item.remoteFileName || '~NO DEFINIDO~' }} -->
                </v-flex>
                <v-layout row>
                  <v-flex>
                    <v-btn small icon class="mx-0" @click="editItem(item)">
                      <v-icon style="color:#00C3D7">edit</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex>
                    <v-btn small icon class="mx-0" @click="removeItem(item)">
                      <v-icon color="red">delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-layout>

            </div>
          </template>

        </template>
        <template v-else>
          <v-container>
            <v-layout wrap>
              <v-flex style="color:rgba(0,0,0,.38)" class="align-center layout">
                No data available
              </v-flex>
            </v-layout>
          </v-container>
        </template>
      </v-card-text>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-actions class="layout justify-center">
        <v-btn
          small depressed round dark
          class="strategio-card-button error"
          @click.native="dialog = false"
        >Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {filter, orderBy} from 'lodash'

import eventBus from '../../utils/eventBus'
import supervisorStorage from '../../storage/supervisorStorage'

export default {
  data () {
    return {
      dialog: false,
      distributorFilter: '',
      distributors: [],
      status: {
        success: { color: 'green' },
        closeSuccess: { color: 'green lighten-2' },
        warning: { color: 'amber' },
        danger: { color: 'red' },
        default: { color: 'grey' },
        base: { color: 'grey lighten-2' }
      }
    }
  },
  created () {
    eventBus.$off('open-show-distributors-dialog')
    eventBus.$on('open-show-distributors-dialog', (distributors) => {
      this.distributors = distributors
      this.dialog = true
    })
  },
  methods: {
    editItem (item) {
      // emit to: /components/dialogs/distributor-form-dialog.vue
      eventBus.$emit('open-distributor-form', item)
    },
    removeItem (item) {
      // emit to: /components/dialogs/are-you-sure-dialog.vue
      eventBus.$emit('open-are-you-sure-dialog', {
        title: 'Eliminar',
        message: '¿Estás seguro de que deseas borrar esta distribuidora?',
        onOk: () => {
          supervisorStorage.removeDistributor({
            data: {
              item: item
            }
          })
        }
      })
    },
    statusColorItem (item) {
      let statusColor = this.status.base.color

      let setDistributorName = (item.distributorName && item.distributorName.trim() !== '')
      let setRemoteFileName = (item.remoteFileName && item.remoteFileName.trim() !== '')
      let setDistributorCode1 = (item.distributorCode1 && item.distributorCode1.trim() !== '')
      let setDistributorCode2 = (item.distributorCode2 && item.distributorCode2.trim() !== '')
      let setDistributorCode3 = (item.distributorCode3 && item.distributorCode3.trim() !== '')

      // Validaciones de estado
      let obligatoryValues = setDistributorName
      let secundaryValues = setRemoteFileName && setDistributorCode1 && setDistributorCode2 // && setDistributorCode3
      let optionalValues = setDistributorCode3

      let someSecundaryValues = setRemoteFileName || setDistributorCode1 || setDistributorCode2 || setDistributorCode3
      let onlyObligatoryValues = obligatoryValues && !secundaryValues
      let normalValues = obligatoryValues && secundaryValues
      let allValues = obligatoryValues && secundaryValues && optionalValues

      let successConfig = allValues
      let closeSuccessConfig = normalValues
      let warningConfig = obligatoryValues && someSecundaryValues
      let defaultConfig = onlyObligatoryValues
      let dangerConfig = !onlyObligatoryValues

      if (successConfig) statusColor = this.status.success.color
      if (closeSuccessConfig) statusColor = this.status.closeSuccess.color
      else if (warningConfig) statusColor = this.status.warning.color
      else if (defaultConfig) statusColor = this.status.default.color
      else if (dangerConfig) statusColor = this.status.danger.color

      return statusColor
    }
  },
  computed: {
    filteredDistributors () {
      let filtered = filter(this.distributors, (distributor) => {
        return distributor.distributorName.toLowerCase().indexOf((this.distributorFilter || '').toLowerCase()) !== -1
      })
      let sorted = orderBy(filtered, ['distributorName', 'remoteFileName'], ['asc', 'asc'])

      return sorted
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/show-distributors-dialog.vue